'use strict';

import ItemView from './PayrollItem.js';
import ModalView from './PayrollItemModal.js';
import template from '../../templates/settings/PayrollItems.ejs';
import PayrollItem from 'newModels/payroll-item.js';
import ListEditablesView from 'commons/views/ListEditables';
import modal from 'helpers/modal';

module.exports = ListEditablesView.extend({
    itemViews: [],
    modalView: null,

    events: function() {
        var parentEvents = _.isFunction(ListEditablesView.prototype.events) ?
            ListEditablesView.prototype.events() :
            ListEditablesView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'click .js-add-addition':  'addAddition',
            'click .js-add-deduction': 'addDeduction',
            'click .js-add-overtime': 'addOvertime'
        });
    },

    initialize: function(options) {
        let filter;

        if (options.defaultPayrollItems) {
            filter = (model) => model.get('hiddenAt') === null;
        } else {
            filter = (model) => (model.get('hiddenAt') === null &&
                model.get('companyId') !== null);
        }

        this.options = _.defaults(options || {}, {
            template:                  template,
            Model:                     PayrollItem,
            ModalEditView:             ModalView,
            ModelView:                 ItemView,
            unsubmittedPayroll:        null,
            unsubmittedPayrollDetails: null,
            filter:                    filter
        });

        this.firstTime = true;

        return ListEditablesView.prototype.initialize.apply(
            this, [this.options]
        );
    },

    renderModel: function(model) {
        let view = new this.options.ModelView({
            model:                     model,
            showReliefOptions: this.options.showReliefOptions,
            unsubmittedPayroll:        this.options.unsubmittedPayroll,
            unsubmittedPayrollDetails: this.options.unsubmittedPayrollDetails
        });

        let type = 'addition';

        // This hacky thing here is because they don't want to update the UI
        // properly so we have to cram items wheverever we can.
        // We now consider items that 'add' as additions
        // and items that subtract as deductions, regardless of type.
        if ([
            'deduction', 'zakat', 'mtd', 'epf', 'socso', 'unpaid_leave',
            'cp38', 'eis', 'hrdf'
        ].indexOf(model.get('type')) >= 0) {
            type = 'deduction';
        } else if (model.get('type') === 'overtime') {
            type = 'overtime';
        }

        //However, the hacky thing mentioned earlier should only be implemented
        //for admin managers
        if (!app.user.isAdmin()) {
            type = model.get('type');
        }

        this.modelViews.push(view);

        this.$('.js-model-' + type + '-views').append(view.$el);

        view.on('edit', this.showEditModal, this);

        return this;
    },

    toggleEmptyMessage: function() {
        _.each(['addition', 'deduction', 'overtime'], function(type) {
            var count = this.collection.filter(function(m) {
                if (app.user.isAdmin()) {
                    let types = [
                        'deduction', 'zakat', 'mtd', 'epf', 'socso',
                        'unpaid_leave', 'cp38'
                    ];
                    if (type === 'deduction') {
                        return types.indexOf(m.get('type')) >= 0;
                    } else if (type === 'addition') {
                        return (
                            types.indexOf(m.get('type')) < 0 &&
                            m.get('type') !== 'overtime'
                        );
                    }
                }

                return m.get('type') === type;
            }).length;
            this.$('.js-empty-' + type).toggleClass('hidden', count > 0);
        }.bind(this));

        return this;
    },

    addAddition: function(ev) {
        ev.preventDefault();
        this.add('addition');
    },

    addDeduction: function(ev) {
        ev.preventDefault();
        this.add('deduction');
    },

    addOvertime: function(ev) {
        ev.preventDefault();
        return this.add('overtime');
    },

    add: function(type) {
        if (!this.modalEditView) {
            return this;
        }

        const attr = {
            type,
            companyId: app.company.id,
            allowRecurrency: true
        };

        if (type === 'overtime') {
            Object.assign(attr, {
                isUnit: true,
                isNet: true,
                isGross: true,
                overtimeFactor: 1.5,
                category: 0,
                affectsMtd: true,
                affectsEpf: false,
                affectsSocso: true,
                affectsEis: true,
                eaFields: ['grossSalary']
            });
        }

        let model = new PayrollItem(attr);
        this.modalEditView.setModel(model).show();
        return this;
    },

    save: function(ev) {
        ListEditablesView.prototype.save.apply(this, [ev]).then(function() {
            modal.showAlertSuccess('Settings have been saved');
        });
        return false;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/PayrollItems.js